/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { AbstractGenFirestoreService } from '@res/ngg-core';
import { OrmService, Schema } from '../schema/orm.service';
@Injectable({
  providedIn: 'root',
  deps: [],
})
export class CompaniesFirestoreService extends AbstractGenFirestoreService<Schema, 'companies'> {
  constructor() {
    super(inject(OrmService).companyCollection);
  }
}
